import { axiosRequest } from "../axios.config";

const balanceApi = {
  getBalance: async () => {
    const url = "ShoppingCart";
    const response = await axiosRequest.get(url);
    return response;
  },
  addBalance: async (data) => {
    const url = "Payment";
    const response = await axiosRequest.post(url, data);
    return response;
  },
  getAllEarning: async (params) => {
    const url = "/Order/Get-all-Earning";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
  getAllStatements: async (params) => {
    const url = "/Order/Get-all-Statements";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
  // deleteItemFromCart: async (data) => {
  //   const url = `ShoppingCart/?courseId=${data.itemId}`;
  //   const response = await axiosRequest.delete(url);
  //   return response;
  // },
  // handleCart: async (data) => {
  //   const url = `ShoppingCart?courseId=${data.id}`;
  //   const response = await axiosRequest.put(url, {
  //     courseId: data.id,
  //     isActive: data.isActive,
  //   });
  //   return response;
  // },
  // addOrder: async (data) => {
  //   const url = "Order";
  //   const response = await axiosRequest.post(url, data);
  //   return response;
  // },
};

export { balanceApi };
